<template>
  <v-card
    elevation="6"
    class="article-card card-wrapper d-flex"
    tile
    flat
    :to="'/services/' + content.slug"
    @click.native="scrollToTop"
  >
    <v-img :src="getImageURI(content.image)">
      <div class="article-card d-flex flex-column justify-end">
        <div
          class="card-caption lightgray d-flex flex-column justify-space-between"
        >
          <v-card-title class="card-title pa-0">
            {{ content.title | truncate }}
          </v-card-title>
          <v-card-text class="card-date pa-0">
            <!-- <div class="d-flex flex-wrap flex-column align-content-space-between"> -->
            {{ content.university }}
            <!-- <span>{{ moment(content.date).format('DD MMMM YYYY') }}</span> -->
            <!-- </div> -->
          </v-card-text>
        </div>
      </div>
    </v-img>
  </v-card>
</template>

<script>
export default {
  name: 'ServiceCard',
  props: {
    content: {
      type: Object,
    },
  },
  methods: {
    getImageURI(imageName) {
      if (imageName) {
        return require(`../assets/images/services/${imageName}`)
      }
      return 'https://cdn.vuetifyjs.com/images/cards/house.jpg'
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.card-wrapper {
  // border: 4px solid rgba(#f2f2f2, 0);
  // &:hover {
  //   border: 4px solid #268c79;
  // }
}

.article-card {
  height: 240px;
}

.card-caption {
  width: 100%;
  min-height: 80px;
  padding: 8px;
  opacity: 0.9;
}

.card-title {
  font-family: $heading-font-family;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-transform: uppercase;
  overflow-wrap: normal;
  word-break: normal;
}

.card-date {
  font-family: $body-font-family;
  font-weight: lighter;
  font-size: 14px;
  text-align: right;
}
</style>
